/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentDetailsInternalTransferInvestmentViewModel } from './PaymentDetailsInternalTransferInvestmentViewModel';
import {
    PaymentDetailsInternalTransferInvestmentViewModelFromJSON,
    PaymentDetailsInternalTransferInvestmentViewModelFromJSONTyped,
    PaymentDetailsInternalTransferInvestmentViewModelToJSON,
} from './PaymentDetailsInternalTransferInvestmentViewModel';
import type { PaymentDetailsSourceOfMoneyViewModel } from './PaymentDetailsSourceOfMoneyViewModel';
import {
    PaymentDetailsSourceOfMoneyViewModelFromJSON,
    PaymentDetailsSourceOfMoneyViewModelFromJSONTyped,
    PaymentDetailsSourceOfMoneyViewModelToJSON,
} from './PaymentDetailsSourceOfMoneyViewModel';

/**
 * 
 * @export
 * @interface PaymentDetailsInternalTransferViewModel
 */
export interface PaymentDetailsInternalTransferViewModel {
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsInternalTransferViewModel
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsInternalTransferViewModel
     */
    amount?: number;
    /**
     * 
     * @type {Array<PaymentDetailsInternalTransferInvestmentViewModel>}
     * @memberof PaymentDetailsInternalTransferViewModel
     */
    investments: Array<PaymentDetailsInternalTransferInvestmentViewModel>;
    /**
     * 
     * @type {Array<PaymentDetailsSourceOfMoneyViewModel>}
     * @memberof PaymentDetailsInternalTransferViewModel
     */
    sourcesOfMoney: Array<PaymentDetailsSourceOfMoneyViewModel>;
}

/**
 * Check if a given object implements the PaymentDetailsInternalTransferViewModel interface.
 */
export function instanceOfPaymentDetailsInternalTransferViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "investments" in value;
    isInstance = isInstance && "sourcesOfMoney" in value;

    return isInstance;
}

export function PaymentDetailsInternalTransferViewModelFromJSON(json: any): PaymentDetailsInternalTransferViewModel {
    return PaymentDetailsInternalTransferViewModelFromJSONTyped(json, false);
}

export function PaymentDetailsInternalTransferViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentDetailsInternalTransferViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'amount': !exists(json, 'Amount') ? undefined : json['Amount'],
        'investments': ((json['Investments'] as Array<any>).map(PaymentDetailsInternalTransferInvestmentViewModelFromJSON)),
        'sourcesOfMoney': ((json['SourcesOfMoney'] as Array<any>).map(PaymentDetailsSourceOfMoneyViewModelFromJSON)),
    };
}

export function PaymentDetailsInternalTransferViewModelToJSON(value?: PaymentDetailsInternalTransferViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'Amount': value.amount,
        'Investments': ((value.investments as Array<any>).map(PaymentDetailsInternalTransferInvestmentViewModelToJSON)),
        'SourcesOfMoney': ((value.sourcesOfMoney as Array<any>).map(PaymentDetailsSourceOfMoneyViewModelToJSON)),
    };
}

